import { render, staticRenderFns } from "./VictoryMiniPanel.vue?vue&type=template&id=109a2f91&"
import script from "./VictoryMiniPanel.vue?vue&type=script&lang=js&"
export * from "./VictoryMiniPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports